import { Flex, Spin } from 'antd';

const PageLoading = () => (
  <Flex align="center" justify="center" style={{ minHeight: 280 }}>
    <Spin size="large" tip="页面加载中..." />
  </Flex>
);

export default PageLoading;
